export default __webpack_public_path__ + "static/globe-right-new-7240ffa2793de44101eff29a71d8f64b.png";